import { render, staticRenderFns } from "./InvestorDetailModal.vue?vue&type=template&id=3cd0d424&scoped=true"
import script from "./InvestorDetailModal.vue?vue&type=script&lang=js"
export * from "./InvestorDetailModal.vue?vue&type=script&lang=js"
import style0 from "./InvestorDetailModal.vue?vue&type=style&index=0&id=3cd0d424&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd0d424",
  null
  
)

export default component.exports